if (!customElements.get('recipient-form')) {
  class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('[data-recipient-checkbox]');
      this.fallback = this.querySelector('[data-recipient-fallback]');
      this.fieldsWrapper = this.querySelector('.recipient-fields');
      this.emailInput = this.querySelector('[data-recipient-email]');
      this.nameInput = this.querySelector('[data-recipient-name]');
      this.messageInput = this.querySelector('[data-recipient-message]');
      this.sendOnInput = this.querySelector('[data-recipient-send-on]');
      this.offsetInput = this.querySelector('[data-recipient-offset]');
      this.form = this.closest('form');

      this.handleToggle = this.handleToggle.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    connectedCallback() {
      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this.checkbox?.addEventListener('change', this.handleToggle, { signal });
      this.form?.addEventListener('submit', this.handleSubmit, { signal });
    }

    disconnectedCallback() {
      this._abortController?.abort();
    }

    get recipientFields() {
      return [this.emailInput, this.nameInput, this.messageInput, this.sendOnInput];
    }

    handleToggle() {
      const isChecked = this.checkbox.checked;

      this.fieldsWrapper.hidden = !isChecked;

      if (this.fallback) {
        this.fallback.disabled = isChecked;
      }

      this.recipientFields.forEach(field => {
        if (field) field.disabled = !isChecked;
      });

      if (isChecked) {
        if (this.offsetInput) {
          this.offsetInput.disabled = false;
          this.offsetInput.value = new Date().getTimezoneOffset();
        }
      } else {
        if (this.offsetInput) {
          this.offsetInput.disabled = true;
          this.offsetInput.value = '';
        }
        this.clearFields();
      }
    }

    clearFields() {
      this.recipientFields.forEach(field => {
        if (field) field.value = '';
      });
      this.clearEmailError();
    }

    handleSubmit(event) {
      if (!this.reportValidity()) {
        event.preventDefault();
      }
    }

    reportValidity() {
      if (!this.checkbox?.checked) return true;

      const email = this.emailInput?.value.trim() ?? '';
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

      if (!isValidEmail) {
        this.showEmailError();
        this.emailInput?.focus();
        return false;
      }

      this.clearEmailError();
      return true;
    }

    showEmailError() {
      const wrapper = this.emailInput?.closest('.form-field');
      if (!wrapper) return;

      wrapper.classList.add('form-field--error');

      let errorElement = wrapper.querySelector('[data-recipient-email-error]');
      if (!errorElement) {
        errorElement = document.createElement('p');
        errorElement.className = 'form-field__error';
        errorElement.setAttribute('role', 'alert');
        errorElement.setAttribute('data-recipient-email-error', '');
        wrapper.appendChild(errorElement);
      }
      errorElement.textContent = theme.locales.cart.lineError.giftCardRecipientRequired;
    }

    clearEmailError() {
      const wrapper = this.emailInput?.closest('.form-field');
      wrapper?.classList.remove('form-field--error');
      wrapper?.querySelector('[data-recipient-email-error]')?.remove();
    }
  }

  customElements.define('recipient-form', RecipientForm);
}
